// Bilingual copy for ARTLENSS
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      work: "Work",
      methodology: "Methodology",
      awards: "Awards",
      blog: "Blog",
      contact: "Contact",
      cta: "Start Your Project",
    },
    hero: {
      eyebrow: "Cinematic Studio · Jeddah, Saudi Arabia",
      badgeTitle: "25 Years of Cinematic Excellence",
      badgeSub: "Mastering the art of visual storytelling for two and a half decades.",
      title1: "We Craft",
      title2: "Cinematic Stories",
      title3: "That Move People.",
      sub: "From documentaries to commercials, drama, 3D visuals, and AI-powered content, Art Lens turns ideas into unforgettable cinematic experiences.",
      viewWork: "View Our Work",
      startProject: "Start Your Project",
      downloadProfile: "Download Studio Profile",
      watchIntro: "Watch Intro Video",
      downloadToast: "Studio profile is being updated — download will be available soon.",
      scroll: "Scroll to explore",
    },
    home: {
      featuredEyebrow: "Selected Work",
      featuredTitle: "How we craft works at ARTLENSS",
      featuredSub: "A curated glimpse into commercials, documentaries, drama, and AI-driven visuals produced across Saudi Arabia and the Arab region.",
      viewAll: "View full portfolio",
      btsEyebrow: "Behind the Scenes",
      btsTitle: "Inside our set — how the frame is made",
      btsSub: "A closer look at the craft — the rigs, the lighting, the crew moves that turn a brief into a cinematic frame.",

      servicesEyebrow: "What We Do",
      servicesTitle: "End-to-end cinematic production",
      servicesSub: "One studio, nine disciplines — engineered to translate ambitious briefs into precise, unforgettable visual language.",
      blogEyebrow: "From the ARTLENSS Journal",
      blogTitle: "Latest notes & essays",
      blogSub: "Fresh reflections and behind-the-lens stories from our ongoing cinematic practice.",
      blogReadMore: "Read more",
      blogExploreAll: "Explore all articles",

      whyEyebrow: "Why Art Lens",
      whyTitle: "Precision meets poetry",
      whySub: "We treat every frame as a decision. The result is work that not only looks cinematic — it feels inevitable.",

      testEyebrow: "Client Voices",
      testTitle: "Our clients' opinions",

      clientsEyebrow: "Selected Clients",
      clientsTitle: "Partnered with leaders across the region",
    },
    cats: {
      All: "All",
      Documentary: "Documentary",
      Commercial: "Commercial",
      Drama: "Drama",
      "Music Video": "Music Video",
      "Motion & 3D": "Motion & 3D",
      "Motion Graphics": "Motion Graphics",
      "Product Photography": "Product Photography",
      "Sound Recording": "Sound Recording",
      Event: "Event",
      Announcement: "Announcement",
      "Behind the Scenes": "Behind the Scenes",
    },
    services: {
      title: "Services",
      eyebrow: "Our Services",
      lead: "From the first spark of an idea to the final grade, every discipline under one cinematic roof.",
      requestQuote: "Request a Quote",
      processTitle: "Process",
      itemsIntro: "What we deliver",
    },
    about: {
      eyebrow: "About the Studio",
      title: "A Jeddah-based studio, obsessed with cinematic craft.",
      lead: "Founded by experienced filmmakers and artists, Art Lens is a creative production studio based in Jeddah, Saudi Arabia. We specialize in turning complex ideas into powerful visual stories that connect with audiences.",
      missionTitle: "Mission",
      missionText: "To elevate the visual language of the Arab region by producing cinematic work that is emotionally honest, technically flawless, and culturally resonant.",
      visionTitle: "Vision",
      visionText: "The reference studio in Saudi Arabia for storytellers who refuse the ordinary: blending classical cinema with modern vision techniques.",
      teamEyebrow: "The People",
      teamTitle: "A tight, hand-picked crew",
      teamSub: "Directors, producers, cinematographers, editors, 3D and AI specialists — moving as one unit from pre-production to delivery.",
      valuesEyebrow: "Values",
      valuesTitle: "Four principles, on every project.",

      storyEyebrow: "Our Story",
      storyTitle: "A quarter century behind the Saudi lens.",
      story: [
        "From the heart of Jeddah, ARTLENSS was born as a purely Saudi cinematic vision — a studio that has spent twenty-five years watching the Kingdom evolve, and choosing, one frame at a time, to translate that evolution into image, sound, and story. We do not consider ourselves service providers of visual content; we consider ourselves custodians of a national memory that deserves to be seen in cinematic scale.",
        "The studio was founded by director and producer Hani Hijazi, whose personal journey behind the camera spans more than a quarter of a century. From his earliest short films to his large-scale commercial productions and documentary series, Hani has directed hundreds of hours of visual content, producing work that has aired on regional broadcasters, played in cinematic screenings, and traveled with clients into markets they had never imagined entering. His name has become synonymous with a disciplined, warm, cinematic touch that clients from Saudi Arabia and beyond continue to trust.",
        "Twenty-five years of directing means twenty-five years of witnessing. Hani began his career at a time when the Kingdom's screen culture was still whispering; he watched it become one of the loudest cinematic voices in the region. He has directed inside the historic districts of Jeddah, in the volcanic fields of AlUla, along the coasts of Yanbu, and in the corporate towers of Riyadh — documenting a country that reinvented itself in real time. Every ARTLENSS production is, in some way, a document of that transformation.",
        "Under the umbrella of Vision 2030, the studio has aligned itself with the national creative movement — not by adopting its slogans, but by adopting its ambition. Saudi Arabia is producing more films, more series, more advertising, and more cultural content than at any time in its history, and ARTLENSS sees itself as one of the studios helping to raise the bar of what \"Saudi cinematic\" means. We collaborate with government entities, private brands, cultural institutions, and independent creators — always aiming for the same standard: work that would hold its own on any international festival screen.",
        "Our production philosophy is what makes ARTLENSS different: we do not approve every idea that arrives at our door. We approve only the ideas that carry an emotional thread — a scene the viewer will feel long after the credits roll, a character whose eyes are worth returning to, a landscape that becomes memory. This principle is written into every quotation we send, every script we develop, and every rough cut we review. It is why our clients keep returning: they know we protect their story from becoming ordinary.",
        "The studio operates as a full-service creative house: pre-production (concept, script, storyboard, casting, scouting), production (direction, cinematography, sound, drone, motion capture), and post-production (edit, color grading, motion graphics, sound design, mixing, AI-driven enhancement). We invest in the same equipment used on world-class sets — anamorphic optics, cinema cameras, professional lighting, sound-treated recording, and a color-managed post pipeline. But the equipment is only the vehicle; the heart of the studio is a team that has learned, over decades, how to tell stories that matter.",
        "Recognition has followed. ARTLENSS has been honored by leading cultural and industry bodies, including a special shield from the Saudi Producers and Distributors Association — the \"Prophet's Seal Shield\" — awarded in recognition of a quarter century of cinematic contribution to the Kingdom. Our work has been featured in national press, industry showcases, and educational programs teaching the next generation of Saudi filmmakers. Every honor we receive is treated as an obligation to keep raising the standard.",
        "Today, ARTLENSS is more than a production studio. It is a reference point for anyone in the Kingdom or the region who is serious about cinematic storytelling — a place where a brand, a filmmaker, or a national initiative can arrive with an idea and leave with a piece of work worthy of being remembered. That is the studio we have built, and it is the studio we continue to build, one carefully-lit frame at a time.",
      ],

      milestoneYears: "Years behind the camera",
      milestoneProjects: "Cinematic productions delivered",
      milestoneAwards: "Awards & recognitions",
      milestoneCountries: "Countries filmed in",

      achievementsEyebrow: "Recognitions",
      achievementsTitle: "Honors that mark the journey",
      achievementsIntro: "A selection of the honors ARTLENSS has received across a quarter century of cinematic work.",
      achievements: [
        {
          title: "The Prophet's Seal Shield",
          body: "Awarded by the Saudi Producers and Distributors Association in recognition of ARTLENSS's cinematic contributions to the Kingdom over twenty-five years of directing and production."
        },
        {
          title: "Saudi Producers & Distributors Association",
          body: "Formal recognition as a leading contributor to Saudi audiovisual production, with our films and documentaries featured in the Association's showcases and cultural programs."
        },
        {
          title: "Regional Broadcaster Features",
          body: "ARTLENSS productions have aired on multiple regional broadcasters and cultural channels, and have been screened in cinematic events across the Arab region."
        },
        {
          title: "Cultural & Governmental Partnerships",
          body: "Documentary work commissioned by cultural institutions and government-linked entities, contributing to the visual archive of Vision 2030 initiatives."
        },
      ],
    },
    contact: {
      eyebrow: "Get in Touch",
      title: "Let's Create Something Cinematic Together.",
      lead: "Share your idea → We propose a concept → We produce and deliver.",
      formName: "Full Name",
      formEmail: "Email",
      formPhone: "Phone",
      formCompany: "Company (optional)",
      formType: "Project Type",
      formTypePlaceholder: "Select a service",
      formMessage: "Tell us about your project",
      submit: "Send Brief",
      sending: "Sending…",
      successTitle: "Thank you.",
      successBody: "We received your brief and will reply within one business day.",
      infoTitle: "Direct line",
      email: "info@artlenss.com",
      phone: "+966 55 414 2007",
      location: "Jeddah, Saudi Arabia",
      social: "Follow the studio",
      mapCaption: "Studio · Jeddah, KSA",
    },
    work: {
      eyebrow: "Portfolio",
      title: "Selected work, unfiltered.",
      lead: "Filter by discipline — every project links to a full case study with process, tools and the final result.",
      filterLabel: "Filter",
      viewCase: "View case",
      comingSoonTitle: "Coming soon",
      comingSoonSub: "New documentary work is on the way. Stay tuned.",
      workBtsEyebrow: "How we work",
      workBtsTitle: "How we craft works at ARTLENSS",
      workBtsText: "Every Art Lens production follows the same cinematic backbone: <b>idea → script / storyboard → pre-production → production → post-production</b>. Click through to see the full methodology.",
      workBtsCta: "See the full methodology",
    },
    methodology: {
      eyebrow: "Our methodology",
      title: "How we craft works at ARTLENSS",
      lead: "A disciplined, five-step pipeline that turns raw ideas into cinema. Every project passes through it, no shortcut.",
      intro: {
        heading: "It starts with an idea, not a tool",
        paragraphs: [
          "At ARTLENSS, every project begins with an idea — never with a tool.",
          "We choose each work with care: an emotional through-line, a clear objective, and a fully-formed vision — before a single camera rolls.",
          "That idea is then translated into a precise production plan: from script, to storyboard, to shot list, and finally into shoot, edit and grade.",
        ],
      },
      steps: [
        {
          num: "01",
          title: "Idea & Selection",
          desc: "We don't greenlight every idea; we only commit to work carrying a strong emotional through-line, a clear objective, and a fully-formed image already living in the director's mind.",
          bullets: [
            "The idea passes a curation filter: does it fit the project identity?",
            "Does it carry a message worth telling?",
            "Can it be told visually?",
          ],
        },
        {
          num: "02",
          title: "Script & Storyboard",
          desc: "The story comes first. Every work is drawn on paper before it's ever shot:",
          bullets: [
            "We write the script — dialogue, description, emotional beats.",
            "Then the storyboard — every frame, every movement, every light source.",
            "This is where the film's cinematic language is engineered, not just its content.",
          ],
        },
        {
          num: "03",
          title: "Pre-Production",
          desc: "From the storyboard, the work moves into the production plan:",
          bullets: [
            "Locking the crews, equipment, locations and schedule.",
            "In-house pre-vis and on-set data wrangling.",
            "A dedicated producer per project, matched to the camera family and the editorial style the story needs.",
          ],
        },
        {
          num: "04",
          title: "Production (Shoot)",
          desc: "We shoot on broadcast-grade cinema bodies (ARRI, RED, Sony Venice) with calibrated setups.",
          bullets: [
            "Every frame is captured as a cinematic decision, not a technical demo.",
            "Lighting, movement and color are designed as part of the emotional narrative.",
            "Sound, art direction and DP work as one unit.",
          ],
        },
        {
          num: "05",
          title: "Post-Production & Grade",
          desc: "After the shoot, the work moves into the finishing stage:",
          bullets: [
            "Story assembly, noise treatment and audio conform.",
            "Color grade tuned to serve the emotional mood of every scene.",
            "The result: work that doesn't just look cinematic — it feels inevitable.",
          ],
        },
      ],
      ctaText: "Ready to start a project like this?",
      ctaBtn: "Start a project",
    },
    awards: {
      eyebrow: "Awards & Recognition",
      title: "Twenty-five years, engraved in gold.",
      lead: "Welcome to a corner of ARTLENSS reserved for gratitude — a curated wall of shields, plaques and letters of appreciation gathered across a quarter-century of committed, professional cinematic work. Every piece here carries the story of a partnership, a project delivered, and a promise kept.",
      stat1: "25+ years of cinema",
      stat2: "Selected honours below · continuously updated",
      ctaEyebrow: "Trusted by institutions",
      ctaTitle: "Let's craft the next chapter — together.",
      ctaBtn: "Start a project",
    },
    blog: {
      eyebrow: "The Journal",
      title: "Field notes from the cutting room.",
      lead: "Reflections, essays and behind-the-lens stories from our ongoing cinematic practice — bilingual, unhurried, made to last.",
      loading: "Loading articles…",
      emptyTitle: "The journal opens soon.",
      emptySub: "The first cinematic notes are being written — check back shortly.",
      readMore: "Read the piece",
      back: "Back to journal",
    },
    project: {
      overview: "Overview",
      client: "Client",
      goal: "Goal",
      timeline: "Timeline",
      approach: "Creative Approach",
      highlights: "Production Highlights",
      equipment: "Equipment",
      locations: "Locations",
      team: "Team",
      tools: "Tools",
      result: "Final Result",
      watch: "Watch the film",
      bts: "Behind the Scenes",
      back: "All work",
      next: "Next project",
    },
    footer: {
      tagline: "Cinematic stories, engineered in Jeddah — released to the world.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      newsletterTitle: "Free directing consultation for your next project!",
      newsletterSub: "Subscribe to our newsletter and receive a 15-minute consultation with director Hani Hijazi to discuss the idea of your cinematic work.",
      newsletterPlaceholder: "Your email address",
      newsletterCta: "Book my consultation",
      newsletterSuccess: "You're successfully registered! Our team will contact you soon to schedule your free consultation.",
      newsletterInvalid: "Please enter a valid email.",
      newsletterExists: "You're already on the list — we'll reach out shortly!",
      newsletterError: "Something went wrong. Please try again.",
      rights: "All rights reserved.",
      built: "Independent studio · est. Jeddah",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      work: "أعمالنا",
      methodology: "منهجيتنا",
      awards: "الجوائز والتقدير",
      blog: "المدونة",
      contact: "تواصل",
      cta: "ابدأ مشروعك",
    },
    hero: {
      eyebrow: "استوديو سينمائي · جدة، المملكة العربية السعودية",
      badgeTitle: "خمسة وعشرون عاماً من التميّز السينمائي",
      badgeSub: "إتقان فنّ السرد البصري على مدى عقدين ونصف.",
      title1: "نصنع",
      title2: "قصصاً سينمائية",
      title3: "تُحرّك المشاعر",
      sub: "من الأفلام الوثائقية إلى الإعلانات التجارية والدراما والمرئيات ثلاثية الأبعاد والمحتوى المدعوم بالذكاء الاصطناعي — نُحوّل الفكرة إلى تجربة سينمائية لا تُنسى.",
      viewWork: "شاهد أعمالنا",
      startProject: "ابدأ مشروعك",
      downloadProfile: "تحميل الملف التعريفي",
      watchIntro: "شاهد الفيديو التعريفي",
      downloadToast: "الملف التعريفي قيد التحديث، سيتوفر للتحميل قريباً.",
      scroll: "استكشف",
    },
    home: {
      featuredEyebrow: "مختارات",
      featuredTitle: "كيف نصنع الأعمال في ARTLENSS",
      featuredSub: "نافذة موجزة على إعلاناتنا وأفلامنا الوثائقية والدرامية والمرئيات المدعومة بالذكاء الاصطناعي في المملكة والمنطقة العربية.",
      viewAll: "شاهد المعرض كاملاً",
      btsEyebrow: "خلف الكواليس",
      btsTitle: "من داخل موقع التصوير — كيف يُصنع الكادر",
      btsSub: "نظرة أقرب على الحِرفة: التجهيزات، الإضاءة، وحركة الفريق التي تُحوّل الفكرة إلى كادرٍ سينمائي.",

      servicesEyebrow: "ماذا نقدّم",
      servicesTitle: "إنتاج سينمائي متكامل من الفكرة حتى التسليم",
      servicesSub: "استوديو واحد، تسع تخصصات — لتحويل الأفكار الطموحة إلى لغة بصرية دقيقة لا تُنسى.",
      blogEyebrow: "من مدونة Art Lens",
      blogTitle: "آخر الأخبار والمقالات",
      blogSub: "تأمّلاتٌ وحكاياتٌ من خلف العدسة، بلغةٍ سينمائية متأنية.",
      blogReadMore: "اقرأ المزيد",
      blogExploreAll: "استكشف كافة المقالات",

      whyEyebrow: "لماذا Art Lens",
      whyTitle: "الدقة تلتقي الشِّعر",
      whySub: "كل كادر عندنا قرار — والنتيجة عمل لا يبدو سينمائياً فحسب، بل يبدو حتمياً.",

      testEyebrow: "آراء العملاء",
      testTitle: "آراء عملائنا",

      clientsEyebrow: "عملاء مختارون",
      clientsTitle: "شركاء رواد في المنطقة",
    },
    cats: {
      All: "الكل",
      Documentary: "وثائقي",
      Commercial: "إعلاني",
      Drama: "درامي",
      "Music Video": "فيديو موسيقي",
      "Motion & 3D": "موشن و ٣د",
      "Motion Graphics": "موشن جرافيك",
      "Product Photography": "تصوير المنتجات",
      "Sound Recording": "تسجيل صوتي",
      Event: "فعاليات",
      Announcement: "إعلان",
      "Behind the Scenes": "خلف الكواليس",
    },
    services: {
      title: "خدماتنا",
      eyebrow: "خدماتنا",
      lead: "من أول شرارة للفكرة حتى التصحيح اللوني النهائي — كل التخصصات تحت سقف سينمائي واحد.",
      requestQuote: "اطلب عرض سعر",
      processTitle: "مراحل العمل",
      itemsIntro: "ما نُسلّم",
    },
    about: {
      eyebrow: "عن الاستوديو",
      title: "استوديو من قلب جدة، مهووس بالحِرفة السينمائية.",
      lead: "أسّس Art Lens مجموعة من صنّاع الأفلام والفنانين، وهو استوديو إنتاج إبداعي مقرّه جدة، المملكة العربية السعودية. نتخصّص في تحويل الأفكار المعقدة إلى قصص بصرية قوية تُلامس الجمهور.",
      missionTitle: "رسالتنا",
      missionText: "الارتقاء باللغة البصرية في المنطقة العربية عبر إنتاج أعمال سينمائية صادقة عاطفياً، متقنة تقنياً، وعميقة ثقافياً.",
      visionTitle: "رؤيتنا",
      visionText: "الاستوديو المرجعي في المملكة لصنّاع القصص الذين يرفضون العادي: دمج السينما الكلاسيكية مع تقنيات الرؤية الحديثة.",
      teamEyebrow: "فريقنا",
      teamTitle: "طاقم مختار بعناية",
      teamSub: "مخرجون ومنتجون ومصورون ومونتيرون ومتخصصو ٣د وذكاء اصطناعي — يعملون كوحدة واحدة من التحضير حتى التسليم.",
      valuesEyebrow: "قِيَمنا",
      valuesTitle: "أربعة مبادئ في كل مشروع.",

      storyEyebrow: "حكايتنا",
      storyTitle: "ربع قرن خلف العدسة السعودية.",
      story: [
        "من قلب جدة، وُلد ARTLENSS رؤيةً سينمائيةً سعوديّةً خالصة — استوديو أمضى خمساً وعشرين سنةً يراقب المملكة وهي تتحوّل، ويختار — كادراً بعد كادر — أن يترجم ذلك التحوّل إلى صورة وصوت وحكاية. لا نعتبر أنفسنا مزوّدي محتوى بصري؛ نعتبر أنفسنا حرّاساً لذاكرةٍ وطنيّةٍ تستحق أن تُرى بمقاسٍ سينمائي.",
        "أسّس الاستوديو المخرج والمنتج هاني حجازي، الذي تمتدّ رحلته الشخصية خلف الكاميرا لأكثر من ربع قرن. من أفلامه القصيرة الأولى، إلى إنتاجاته التجارية الكبرى، إلى سلاسله الوثائقية، أخرج هاني مئات الساعات من المحتوى البصري، وأنتج أعمالاً بُثّت على القنوات الإقليمية، وعُرضت في المهرجانات السينمائية، وسافرت مع عملائه إلى أسواقٍ لم يتخيّلوا يوماً دخولها. صار اسمه مرادفاً للمسة سينمائيّة منضبطة ودافئة، يثق بها العملاء داخل المملكة وخارجها.",
        "خمسة وعشرون عاماً من الإخراج تعني خمسة وعشرين عاماً من الشهادة. بدأ هاني رحلته حين كانت ثقافة الشاشة في المملكة لا تزال تهمس، ورافقها حتى صارت من أعلى الأصوات السينمائيّة في المنطقة. أخرج داخل الأحياء التاريخيّة في جدة، وفي حرّات العُلا البركانيّة، وعلى شواطئ ينبع، وفي الأبراج المؤسّسيّة في الرياض — يوثّق دولةً أعادت اختراع نفسها في الوقت الحقيقي. كلّ إنتاج من ARTLENSS هو، بطريقةٍ ما، وثيقةٌ لذلك التحوّل.",
        "تحت مظلّة رؤية 2030، ينحاز الاستوديو للحراك الإبداعيّ الوطنيّ — لا بتبنّي شعاراته، بل بتبنّي طموحه. المملكة اليوم تُنتج من الأفلام والمسلسلات والإعلانات والمحتوى الثقافيّ أكثر ممّا أنتجته في تاريخها، ويرى ARTLENSS نفسه أحد الاستوديوهات التي ترفع سقف ما يعنيه \"السينمائي السعودي\". نتعاون مع الجهات الحكوميّة والعلامات الخاصّة والمؤسّسات الثقافيّة والمبدعين المستقلّين — دائماً بالمعيار ذاته: عملٌ يصمد على أيّ شاشة مهرجانٍ عالمي.",
        "فلسفتنا في الإنتاج هي ما يُميّز ARTLENSS: نحن لا نعتمد كلّ فكرة تصلنا. نعتمد فقط الأفكار التي تحمل خيطاً عاطفياً — مشهداً سيشعر به المُشاهد بعد نهاية العمل، شخصيّةً تستحقّ العودة إلى عينَيها، أرضاً تتحوّل إلى ذاكرة. هذا المبدأ مكتوبٌ في كلّ عرض سعرٍ نُصدره، وكلّ سيناريو نُطوّره، وكلّ مسوّدة مونتاجٍ نراجعها. لذلك يعود إلينا عملاؤنا: يعلمون أنّنا نحمي حكاياتهم من الوقوع في العاديّة.",
        "يعمل الاستوديو كدارٍ إبداعيّة متكاملة: ما قبل الإنتاج (الفكرة، السيناريو، الستوري بورد، اختيار الممثلين، معاينة المواقع)، والإنتاج (الإخراج، التصوير، الصوت، الدرون، التقاط الحركة)، وما بعد الإنتاج (المونتاج، تصحيح الألوان، الموشن جرافيك، تصميم الصوت، المكس، والتحسين بالذكاء الاصطناعي). نستثمر في المعدّات نفسها التي تُستخدم في مواقع التصوير العالميّة — عدسات أناموروفيك، كاميرات سينما، إضاءة احترافيّة، غرف تسجيلٍ معزولة، وخطّ عمل ما بعد إنتاجٍ مُدار الألوان. لكنّ المعدّات ليست إلّا وسيلة؛ روح الاستوديو فريقٌ تعلّم — على مدى عقود — كيف يروي القصص التي تستحقّ أن تُروى.",
        "تبع ذلك التقدير. حاز ARTLENSS على تكريمات من جهاتٍ ثقافيّة وصناعيّة كبرى في المملكة، من بينها درعٌ خاصّ من جمعيّة المنتجين والموزّعين السعوديّين — \"درع خاتم النبيّ\" — تقديراً لربع قرنٍ من العطاء السينمائيّ للمملكة. تناولت أعمالنا الصحافةُ الوطنيّة، وعُرضت في محافل صناعيّة، وأُدرجت في برامج تدريبيّة تُدرّس الجيل القادم من صنّاع الأفلام السعوديّين. كلّ تكريمٍ نستلمه نتعامل معه كمسؤوليّة لرفع السقف من جديد.",
        "اليوم، ARTLENSS أكثر من مجرّد استوديو إنتاج. هو مرجعٌ لكلّ من في المملكة أو المنطقة يأخذ صناعة الحكاية السينمائيّة بجدّية — مكانٌ تصل إليه علامة، أو صانع أفلام، أو مبادرة وطنيّة بفكرة، فيغادر بعملٍ يستحقّ أن يُتذكّر. هذا هو الاستوديو الذي بنيناه، وهذا هو الاستوديو الذي نواصل بناءه — كادراً مُضاءً بعناية تلو الآخر.",
      ],

      milestoneYears: "عاماً خلف الكاميرا",
      milestoneProjects: "إنتاج سينمائي مُسلَّم",
      milestoneAwards: "جائزة وتكريم",
      milestoneCountries: "دول صوَّرنا فيها",

      achievementsEyebrow: "التكريمات",
      achievementsTitle: "شهاداتٌ تُوثّق الطريق",
      achievementsIntro: "مختاراتٌ من التكريمات التي نالها ARTLENSS على مدار ربع قرنٍ من العمل السينمائي.",
      achievements: [
        {
          title: "درع خاتم النبيّ",
          body: "تكريمٌ خاصّ من جمعيّة المنتجين والموزّعين السعوديّين تقديراً لإسهامات ARTLENSS السينمائيّة في المملكة عبر خمسة وعشرين عاماً من الإخراج والإنتاج."
        },
        {
          title: "جمعيّة المنتجين والموزّعين السعوديّين",
          body: "تكريمٌ رسميّ باعتبارنا من أبرز المساهمين في الإنتاج السمعيّ البصريّ السعوديّ، مع عرض أفلامنا ووثائقياتنا في محافل الجمعيّة وبرامجها الثقافيّة."
        },
        {
          title: "بثّ على قنواتٍ إقليميّة",
          body: "بُثّت إنتاجات ARTLENSS على عدّة قنوات إقليميّة وثقافيّة، وعُرضت في فعاليّاتٍ سينمائيّة في المنطقة العربيّة."
        },
        {
          title: "شراكاتٌ ثقافيّة وحكوميّة",
          body: "أعمالٌ وثائقيّة كُلِّفنا بها من مؤسّساتٍ ثقافيّة وجهاتٍ ذات ارتباطٍ حكوميّ، ساهمت في تكوين الأرشيف البصريّ لمبادرات رؤية 2030."
        },
      ],
    },
    contact: {
      eyebrow: "تواصل معنا",
      title: "لنصنع شيئاً سينمائياً معاً",
      lead: "شارك فكرتك ← نُقدّم مقترحاً إبداعياً ← ننتج ونُسلّم.",
      formName: "الاسم الكامل",
      formEmail: "البريد الإلكتروني",
      formPhone: "الجوال",
      formCompany: "الجهة (اختياري)",
      formType: "نوع المشروع",
      formTypePlaceholder: "اختر خدمة",
      formMessage: "أخبرنا عن مشروعك",
      submit: "أرسل الطلب",
      sending: "جارٍ الإرسال…",
      successTitle: "شكراً لك.",
      successBody: "استلمنا طلبك وسنعود إليك خلال يوم عمل واحد.",
      infoTitle: "خط مباشر",
      email: "info@artlenss.com",
      phone: "+966 55 414 2007",
      location: "جدة، المملكة العربية السعودية",
      social: "تابع الاستوديو",
      mapCaption: "الاستوديو · جدة، المملكة العربية السعودية",
    },
    work: {
      eyebrow: "المعرض",
      title: "مختاراتنا كما هي.",
      lead: "افرز بالتخصص — كل مشروع يفتح صفحة حالة كاملة تشرح المراحل والأدوات والنتيجة.",
      filterLabel: "تصفية",
      viewCase: "افتح الحالة",
      comingSoonTitle: "انتظرونا قريباً",
      comingSoonSub: "أعمال وثائقية جديدة في الطريق. ترقّبوا الإصدارات القادمة.",
      workBtsEyebrow: "منهجية عملنا",
      workBtsTitle: "كيف نصنع الأعمال في ARTLENSS",
      workBtsText: "كل إنتاج في Art Lens يمرّ بالعمود الفقري السينمائي ذاته: <b>الفكرة ← السيناريو / الستوري بورد ← ما قبل الإنتاج ← الإنتاج ← ما بعد الإنتاج</b>. اضغط لتصفح المنهجية كاملة.",
      workBtsCta: "شاهد المنهجية كاملة",
    },
    methodology: {
      eyebrow: "منهجيتنا",
      title: "كيف نصنع الأعمال في ARTLENSS",
      lead: "خط إنتاج منضبط من خمس مراحل يُحوّل الأفكار الخام إلى سينما. كل مشروع يمرّ بها كاملةً، بلا اختصارات.",
      intro: {
        heading: "تبدأ من فكرة، لا من أداة",
        paragraphs: [
          "في ARTLENSS، كل مشروع يبدأ من فكرة، لا من أداة.",
          "نختار كل عمل بحرص: خيط عاطفي، هدف واضح، وخيال مكتمل قبل أن تبدأ الكاميرا.",
          "ثم تتحوّل هذه الفكرة إلى خطة إنتاجية دقيقة: من السكربت، إلى الـ storyboard، إلى الـ shot list، ثم إلى التصوير والمونتاج.",
        ],
      },
      steps: [
        {
          num: "٠١",
          title: "الفكرة والاختيار",
          desc: "لا نعتمد كل فكرة؛ نعتمد ما يملك خيطاً عاطفياً قوياً، وهدفاً واضحاً، وصورة مكتملة في ذهن المخرج.",
          bullets: [
            "الفكرة تمرّ في صيغة انتقاء: هل تناسب هوية المشروع؟",
            "هل تحمل رسالة تستحق أن تُروى؟",
            "هل يمكن سردها بصرياً؟",
          ],
        },
        {
          num: "٠٢",
          title: "السكربت والـ Storyboard",
          desc: "القصة أولاً. كل عمل يُرسم على الورق قبل أن يُصوَّر:",
          bullets: [
            "نكتب السكربت: حوار، وصف، إشارات عاطفية.",
            "ثم الـ storyboard: كل كادر، كل حركة، كل مصدر إضاءة.",
            "هنا تُصنع لغة العمل السينمائية، لا محتواه فقط.",
          ],
        },
        {
          num: "٠٣",
          title: "التخطيط والإعداد (Pre-Production)",
          desc: "من الـ storyboard، ينتقل العمل إلى الـ production plan:",
          bullets: [
            "تحديد الفرق، والمعدات، والمواقع، والجدول الزمني.",
            "إعداد بريـفيز داخلي، وإدارة بيانات في الموقع.",
            "كل مشروع يُصمَّم له منتج مخصّص: من نوع الكاميرا، إلى أسلوب المونتاج.",
          ],
        },
        {
          num: "٠٤",
          title: "التصوير (Production)",
          desc: "نستخدم كاميرات احترافية (مثل ARRI و RED و Sony Venice) بإعدادات معايَرة دقيقة.",
          bullets: [
            "كل كادر يُصوَّر على أساس قرار سينمائي، لا على أساس عرض تقني.",
            "الإضاءة، والحركة، واللون — كلها تُصمَّم لتكون جزءاً من السرد العاطفي.",
            "الصوت والإدارة الفنية ومدير التصوير يعملون كوحدة واحدة.",
          ],
        },
        {
          num: "٠٥",
          title: "المونتاج والمعايرة (Post-Production)",
          desc: "بعد التصوير، ينتقل العمل إلى مرحلة الإنهاء:",
          bullets: [
            "ترتيب القصة، إزالة الضوضاء، ومواءمة الصوت.",
            "معايرة اللون لتخدم الجو العاطفي للمشهد.",
            "النتيجة: عمل لا يبدو سينمائياً فحسب، بل يبدو حتمياً.",
          ],
        },
      ],
      ctaText: "جاهز لتبدأ مشروعاً بهذه الطريقة؟",
      ctaBtn: "ابدأ مشروعك",
    },
    awards: {
      eyebrow: "الجوائز والتقدير",
      title: "خمسٌ وعشرون سنة… محفورة بالذهب.",
      lead: "أهلاً بكم في زاويةٍ خاصّة داخل ARTLENSS مُخصَّصة للامتنان — جدار مُنتقىً من الدروع والشهادات وخطابات التقدير التي جمعناها عبر ربع قرنٍ من العمل السينمائي الملتزم بالاحترافية. كل قطعةٍ هنا تحمل حكاية شراكة، ومشروعاً سُلِّم على وعده، وثقةً استُحقَّت بجدارة.",
      stat1: "أكثر من ٢٥ عاماً في السينما",
      stat2: "أبرز التكريمات بالأسفل · وتُحدَّث باستمرار",
      ctaEyebrow: "موثوقون من أعرق المؤسسات",
      ctaTitle: "لنكتب معاً الفصل التالي.",
      ctaBtn: "ابدأ مشروعك",
    },
    blog: {
      eyebrow: "المجلة",
      title: "ملاحظاتٌ من غرفة المونتاج.",
      lead: "تأمّلاتٌ ومقالاتٌ وقصصٌ من خلف العدسة — بصوتٍ ثنائي اللغة، متأنٍّ، مصنوعٌ ليبقى.",
      loading: "جارِ تحميل المقالات…",
      emptyTitle: "المجلة تفتح قريباً.",
      emptySub: "أوّل المقالات في الطريق — عُد قريباً.",
      readMore: "اقرأ المقال",
      back: "عودة للمجلة",
    },
    project: {
      overview: "نظرة عامة",
      client: "العميل",
      goal: "الهدف",
      timeline: "المدة",
      approach: "المقاربة الإبداعية",
      highlights: "أبرز مراحل الإنتاج",
      equipment: "المعدات",
      locations: "المواقع",
      team: "الفريق",
      tools: "الأدوات",
      result: "النتيجة النهائية",
      watch: "شاهد الفيلم",
      bts: "من خلف الكواليس",
      back: "كل الأعمال",
      next: "المشروع التالي",
    },
    footer: {
      tagline: "قصص سينمائية تُصنع في جدة — وتُطلق إلى العالم.",
      quickLinks: "روابط سريعة",
      services: "خدماتنا",
      contact: "تواصل",
      legal: "قانوني",
      privacy: "سياسة الخصوصية",
      terms: "الشروط والأحكام",
      newsletterTitle: "استشارة إخراجية مجانية لمشروعك القادم!",
      newsletterSub: "اشترك الآن في نشرتنا البريدية واحصل على جلسة استشارية لمدة ١٥ دقيقة مع المخرج هاني حجازي لمناقشة فكرة عملك السينمائي.",
      newsletterPlaceholder: "بريدك الإلكتروني",
      newsletterCta: "احجز استشارتي",
      newsletterSuccess: "تم تسجيلك بنجاح! سيقوم فريقنا بالتواصل معك قريباً لتحديد موعد استشارتك المجانية.",
      newsletterInvalid: "الرجاء إدخال بريد إلكتروني صحيح.",
      newsletterExists: "أنت مسجّل بالفعل — سنتواصل معك قريباً!",
      newsletterError: "حدث خطأ، حاول مرة أخرى.",
      rights: "جميع الحقوق محفوظة.",
      built: "استوديو مستقل · مقره جدة",
    },
  },
};
